import { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';

import { useResizeHandler } from 'support/react/hooks';

export const DEFAULT_SIDEBAR_WIDTH = 450;
export const MIN_SIDEBAR_WIDTH = 300;
export const MAX_SIDEBAR_WIDTH_RATIO = 2 / 3;

export function AssignmentSidebarLegacy({
  width,
  setWidth,
  children,
  startResizing,
  stopResizing,
  collapsed,
}: {
  collapsed?: boolean;
  width: number;
  setWidth: React.Dispatch<React.SetStateAction<number>>;
  children: React.ReactNode;
  startResizing?: () => void;
  stopResizing?: () => void;
}) {
  const resizeHandle = useRef<HTMLDivElement>(null);
  const [isResizing, setIsResizing] = useState(false);

  useResizeHandler(
    resizeHandle,
    useCallback(
      deltaX => {
        setWidth(w => Math.min(window.innerWidth * MAX_SIDEBAR_WIDTH_RATIO, Math.max(MIN_SIDEBAR_WIDTH, w - deltaX)));
      },
      [setWidth],
    ),
    () => {
      setIsResizing(true);
      startResizing?.();
    },
    () => {
      setIsResizing(false);
      stopResizing?.();
    },
  );

  return (
    <Layout
      style={{
        transition: isResizing ? 'none' : 'width 200ms ease-in-out',
        width: collapsed ? 0 : width,
      }}
    >
      <ResizeHandle ref={resizeHandle}>
        <ResizeHandleInner />
      </ResizeHandle>
      {children}
    </Layout>
  );
}

export const Layout = styled.div`
  background-color: #3b4558;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 2px;
`;

const ResizeHandleInner = styled.div`
  width: 2px;
  height: 100%;
  background: #58647a;
`;

const ResizeHandle = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  padding-right: 4px;
  cursor: ew-resize;
  display: block;

  &:hover ${ResizeHandleInner} {
    background: #6b7d9e;
  }
`;
